/* eslint-disable */
import { ServicemeshNavigationItem } from '@helpers/components/navigation';

export const defaultNavigation: ServicemeshNavigationItem[] = [
  {
    id: 'apps',
    title: 'Applications',
    subtitle: '',
    type: 'group',
    icon: 'mat_solid:home',
    children: [
      {
        id: 'apps.academy',
        title: 'Academy',
        type: 'basic',
        icon: 'heroicons_outline:academic-cap',
        link: '/apps/academy',
      },
    ],
  },
];
export const compactNavigation: ServicemeshNavigationItem[] = [
  {
    id: 'apps.academy',
    title: 'Academy',
    type: 'basic',
    icon: 'heroicons_outline:academic-cap',
    link: '/apps/academy',
  },
];
export const futuristicNavigation: ServicemeshNavigationItem[] = [
  {
    id: 'apps',
    title: 'APPS',
    type: 'group',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
export const horizontalNavigation: ServicemeshNavigationItem[] = [
  {
    id: 'apps',
    title: 'Apps',
    type: 'group',
    icon: 'mat_solid:apps',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
